import styled, { keyframes } from "styled-components";
import ProgressSpinIcon from "./ProgressSpinIcon";

const clockwise = keyframes`
  to { transform: rotate(360deg); }
`;

export const LoadingIcon = styled(ProgressSpinIcon)`
  animation: ${clockwise} 1s linear 0s infinite;
`;

export default LoadingIcon;
